<template>
  <router-link
    :to="route"
    class="help-pill"
    v-tooltip="tooltip"
  >
    <span class="help-pill-icon text-primary">
      <font-awesome-icon :icon="icon" size="xs" />
    </span>
    <span class="help-pill-label text-primary">{{ label }}</span>
  </router-link>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { appIconForRoute } from './appIcon.mjs';

const props = defineProps({
  label: { type: String, required: true },
  meta: { type: String, default: '' },
  route: { type: [String, Object], required: true },
});

const router = useRouter();
const icon = computed(() => appIconForRoute(router, props.route));
const tooltip = computed(() => [props.label, props.meta].filter(Boolean).join(' · '));
</script>

<style scoped>
.help-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 100%;
  margin: 0.1rem 0.15rem;
  padding: 0.1rem 0.6rem 0.1rem 0.15rem;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f9fafb;
  line-height: 1.4rem;
  vertical-align: middle;
  text-decoration: none;
  transition: background-color 0.15s, border-color 0.15s;
}

.help-pill:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.help-pill-icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 999px;
  background: white;
  box-shadow: 0 1px 2px rgb(0 0 0 / 15%);
}

.help-pill-label {
  font-weight: 600;
  white-space: nowrap;
}
</style>
